var styles = {"label":"FormLabel-module_label__tL9cq","disabled":"FormLabel-module_disabled__lqcft","text":"FormLabel-module_text__cxfXn"};

export { styles as default };
